export default "__VITE_ASSET__CJuKLBdR__"